<template>
  <ExActionsPopUp
    :value="value"
    icon="checkpoint_pass"
    :destructive="true"
    :headline="'Discard Draft'"
    :htmlInfo="info"
    :actionLabel="'OK'"
    :cancelLabel="'Cancel'"
    :backgroundPatternBottomRight="true"
    :applyBorderClass="true"
    :width="500"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    data-testid="discard-draft-dialog"
    @onAction="emit('onAction')"
    @input="emit('input', $event)"
  />
</template>

<script>
export default {
  name: "DiscardDraftDialog",
};
</script>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

defineProps({
  value: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["onAction", "input"]);

const info = computed(
  () =>
    `You are about to discard this draft.<br />
        This action is irreversible.`
);
</script>

<style scoped>
::v-deep .action_popup_message.message-spaced {
  max-width: 284px !important /* stylelint-disable-line declaration-no-important */;
  margin: 10px auto 0 !important /* stylelint-disable-line declaration-no-important */;
  text-align: center !important /* stylelint-disable-line declaration-no-important */;
}
</style>
